import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-card-alergias-component',
  templateUrl: './card-alergias-component.component.html',
  styleUrls: ['./card-alergias-component.component.scss'],
})
export class CardAlergiasComponentComponent implements OnInit {
  @Input("data") alergias;
  @Input("ultimo") ultimo;
  constructor() { }

  ngOnInit() {
    console.log('=====this.alergias', this.alergias);
    this.alergias.listaAlergia = this.alergias.listaAlergia.sort((a, b) => {
      return a.outra < b.outra ? -1 : a.outra > b.outra ? 1 : 0;
    })
  }

  abrirItem() {
    this.alergias.selecionado = !this.alergias.selecionado;
  }

  dateLabel(date: string) {
    return `${moment(date, "YYYY-MM-DD").format("L")}`;
  }

  selectIcon(tipoAlergia) {
    if (tipoAlergia === "Medicamentos") {
      return "/assets/icons/bottle.svg"
    }
    if (tipoAlergia === "Alimentar") {
      return "/assets/icons/alimentar.svg"
    }
    if (tipoAlergia === "Animal") {
      return "/assets/icons/animais.svg"
    }

  }

}
